import * as types from '../actions/actionTypes';

function actionTypeEndsInSuccess(type) {
  return type.substring(type.length - 8) == '_SUCCESS';
}

const initialState = {
  callsInProgress: 0,
  isFirstLoad: true,
  hasFirstLoadError: false,
  errorMessageList: []
};

export default function ajaxStatusReducer(state = initialState, action) {
  if (action.type === types.BEGIN_AJAX_CALL) {
    return {
      ...state,
      isFirstLoad: state.isFirstLoad,
      callsInProgress: state.callsInProgress + 1
    };
  }

  if (actionTypeEndsInSuccess(action.type)) {
    return {
      ...state,
      isFirstLoad: false,
      callsInProgress: state.callsInProgress - 1
    };
  }

  if(action.type === types.AJAX_CALL_ERROR) {
    return { 
      ...state,
      hasFirstLoadError: state.isFirstLoad === true,
      errorMessageList: state.errorMessageList.concat(action.error),
      callsInProgress: state.callsInProgress - 1
    };
  }

  return state;
}